﻿(function () {
    'use strict';

    var app = angular.module('ui.pagination.module');

    app.directive('dirPagination', ['$timeout' , function ($timeout) {
        return {
            restrict: 'AE',
            scope: {
                totalItems: '=',
                itemsPerPage: '=',
                currentPage: '=',
                maxSize: '=',
                pageChanged: '&'
            },
            template: '<div class="col-md-12" data-ng-if="totalItems>0">' +
            '<div class="col-md-6 nopadding col-sm-auto" style="text-align: left; padding: 0 !important">' +
            '<ul uib-pagination total-items="$parent.totalItems" items-per-page="$parent.itemsPerPage" ng-model="$parent.currentPage" max-size="$parent.dirMaxSize" class="pagination-sm" boundary-links="true" first-text="«" last-text="»" next-text="›" previous-text="‹" force-ellipses="true"></ul>' +
            '</div>' +
            '<div class="col-md-4 nopadding" style="text-align: left">' +
            '<select style="width: 12%; margin: 10px 0; height: 28px;" ng-model="$parent.itemsPerPage" ng-change="changePage()">' +
            '<option>10</option>' +
            '<option>20</option>' +
            '<option>30</option>' +
            '<option>50</option>' +
            '<option>100</option>' +
            '</select> {{ "views.progressdepotorder.itemsPerPage" | translate }}.' +
            '</div>' +
            '<div class="col-md-2 nopadding col-sm-auto" style="font-size: 12px !important; float: right !important; margin: 10px 0; text-align: right">' +
            '<span>{{($parent.currentPage - 1)*$parent.itemsPerPage + 1}}</span> - ' +
            '<span data-ng-if="$parent.currentPage*$parent.itemsPerPage<=$parent.totalItems">{{$parent.currentPage*$parent.itemsPerPage}}</span> ' +
            '<span data-ng-if="$parent.currentPage*$parent.itemsPerPage>$parent.totalItems">{{$parent.totalItems}}</span> ' +
            '<span>de {{ totalItems }} {{ "views.progressdepotorder.items" | translate }}</span>' +
            '</div>' +
            '</div>',
            link: function ($scope, $element, attr) {
                $scope.dirMaxSize = 10;

                if (angular.isDefined($scope.maxSize))
                    $scope.dirMaxSize = angular.copy($scope.maxSize);

                $scope.changePage = function () {
                    $timeout(function () {
                        if ($scope.currentPage == 1)
                            $scope.pageChanged();
                        else
                            $scope.currentPage = 1;
                    }, 1);
                }

                $scope.$watch("currentPage", function (newValue, oldValue) {
                    if (newValue != oldValue) {
                        $timeout(function () {
                            $scope.pageChanged();
                        }, 1);
                    }
                });

            }
        };
    }]);

})();
